import React from "react";
import { Routes, Route } from "react-router-dom";

import Layout from "../layout";
import ScrollToTop from "../components/ScrollToTop";

import ContactUs from "../pages/Contactus";
import Services from "../pages/ServicesPage/Services";
import Pricing from "../pages/Pricing/Pricing";
import Demo from "../pages/Demo/Demo.jsx";

import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import RefundPolicy from "../pages/RefundPolicy";

import PricingPage from "../components/Pricing/PricingPage";
import PaymentPage from "../components/Pricing/PaymentPage";

import PricingSignIn from "../users/pages/Auth/PricingSignIn";
import SignUpView from "../users/pages/Auth/userSignup";
import SignUpView2 from "../users/pages/Auth/CompleteSingUp";

import { OtpPageView } from "../users/pages/Auth/userSignupOtp";
import CreateProfileViewPage from "../users/pages/Auth/userProfileUpdate";

import { PasswordRecover } from "../users/pages/Auth/userForgotPass";
import ForgotVOtpPage from "../users/pages/Auth/userForgotPassOtp";
import { PasswordUpdateViewPage } from "../users/pages/Auth/userPassUpdate";

import NotFoundPage from "../users/pages/NotFoundPage";
import Main from "../components/main/Main.jsx";

export default function MainRoutes() {
  return (
    <>
      <ScrollToTop />

      <Routes>
        {/* =====================================================
            HOME
        ===================================================== */}

        <Route
          path="/"
          element={
            <Layout>
              <Main />
            </Layout>
          }
        />

        {/* =====================================================
            GENERAL PAGES
        ===================================================== */}

        <Route
          path="/service"
          element={
            <Layout>
              <Services />
            </Layout>
          }
        />

        <Route
          path="/contact"
          element={
            <Layout>
              <ContactUs />
            </Layout>
          }
        />

        {/* =====================================================
            PRICING / PAYMENT
        ===================================================== */}

        <Route
          path="/pricing"
          element={
            <Layout>
              <Pricing />
            </Layout>
          }
        />

        <Route
          path="/payment"
          element={
            <Layout>
              <PaymentPage />
            </Layout>
          }
        />

        {/* =====================================================
            DEMO REPORT
        ===================================================== */}

        <Route
          path="/demo-report"
          element={
            <Layout>
              <Demo />
            </Layout>
          }
        />

        {/* =====================================================
            LEGAL PAGES
        ===================================================== */}

        <Route
          path="/privacy-policy"
          element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          }
        />

        <Route
          path="/terms-of-service"
          element={
            <Layout>
              <TermsOfService />
            </Layout>
          }
        />

        <Route
          path="/refund-policy"
          element={
            <Layout>
              <RefundPolicy />
            </Layout>
          }
        />

        {/* =====================================================
            AUTHENTICATION
        ===================================================== */}

        <Route
          path="/signup"
          element={
            <Layout>
              <SignUpView />
            </Layout>
          }
        />

        <Route
          path="/pricing-signup"
          element={
            <Layout>
              <SignUpView2 />
            </Layout>
          }
        />

        <Route
          path="/pricing-signin"
          element={
            <Layout>
              <PricingSignIn />
            </Layout>
          }
        />

        <Route
          path="/get-otp"
          element={
            <Layout>
              <OtpPageView />
            </Layout>
          }
        />

        <Route
          path="/create-profile"
          element={
            <Layout>
              <CreateProfileViewPage />
            </Layout>
          }
        />

        {/* =====================================================
            PASSWORD RECOVERY
        ===================================================== */}

        <Route
          path="/recoverpassword"
          element={
            <Layout>
              <PasswordRecover />
            </Layout>
          }
        />

        <Route
          path="/Verifyotp"
          element={
            <Layout>
              <ForgotVOtpPage />
            </Layout>
          }
        />

        <Route
          path="/Updatepassword"
          element={
            <Layout>
              <PasswordUpdateViewPage />
            </Layout>
          }
        />

        {/* =====================================================
            404
        ===================================================== */}

        <Route
          path="*"
          element={
            <Layout>
              <NotFoundPage />
            </Layout>
          }
        />
      </Routes>
    </>
  );
}
